export async function registerServiceWorker(onUpdate) {
  if (!("serviceWorker" in navigator)) return false;
  const registration = await navigator.serviceWorker.register("/service-worker.js");
  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    worker?.addEventListener("statechange", () => {
      if (worker.state === "installed" && navigator.serviceWorker.controller) onUpdate?.();
    });
  });
  return registration;
}

export async function clearAppCaches() {
  if (!("caches" in window)) return;
  const names = await caches.keys();
  await Promise.all(names.map((name) => caches.delete(name)));
}
